/**
=========================================================
* ClubOS - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// ClubOS base styles
import colors from "assets/theme/base/colors";

const { gradients } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      // Distinct slate color — clearly different from input content text
      color: "#67748e",
      fontWeight: 500,
      fontSize: "1rem",

      // Red mandatory asterisk when using MUI `required` prop
      "& .MuiFormLabel-asterisk": {
        color: "#ea0606",
        fontWeight: 700,
      },
    },
  },
};

export default formLabel;
